<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      show-save-button
      unit="月扣费设置"
      id-key="RentMonSetId"
      :data="data"
      form-label-width="55px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
      @noSave="onSaved"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="学校" prop="SchoolId">
              <el-select size="mini" v-model="data.SchoolId" @change="checkSet" style="width:100%;">
                <el-option
                  v-for="(i,key) in schools"
                  :key="key"
                  :label="i.SchoolName"
                  :value="i.SchoolId"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="data.Kind==='话费'">
          <el-col :span="24">
            <el-form-item label="分组" prop="GroupId">
              <el-select size="mini" v-model="data.GroupId" style="width:100%;" clearable>
                <el-option
                  v-for="(i,key) in groups"
                  :key="key"
                  :label="i.GroupName"
                  :value="i.GroupId"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:10">
            <el-form-item label="月份" prop="RentMon">
              <el-date-picker
                v-model="data.RentMon"
                type="month"
                @change="setDate"
                value-format="yyyy-MM"
                size="mini"
                placeholder="选择月份"
                style="width:100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="isMB">
            <el-form-item label="类型" prop="Kind">
              <el-select v-model="data.Kind" size="mini" style="width:100%;" @change="changeKind">
                <el-option value="话费"></el-option>
                <el-option value="赠送" v-if="hasSet"></el-option>
                <!-- <el-option value="增值话费" v-if="hasSet"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14" v-else>
            <el-form-item :label="data.Kind=='话费'?'预约扣费时间':'预约赠送时间'" class="waitLabel" prop="WaitTime">
              <el-date-picker
                v-model="data.WaitTime"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                size="mini"
                type="datetime"
                placeholder="选择日期"
                style="width:100%;"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="isMB">
            <el-form-item :label="data.Kind=='话费'?'预约扣费时间':'预约赠送时间'" class="longLabel" prop="WaitTime">
              <el-date-picker
                v-model="data.WaitTime"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                size="mini"
                type="datetime"
                placeholder="选择日期"
                style="width:100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-else>
            <el-form-item label="类型" prop="Kind">
              <el-select v-model="data.Kind" size="mini" style="width:100%;" @change="changeKind">
                <el-option value="话费"></el-option>
                <el-option value="赠送" v-if="hasSet"></el-option>
                <!-- <el-option value="增值话费" v-if="hasSet"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:14" v-if="data.Kind=='话费'">
            <el-form-item label="扣费成功通知时间" :class="isMB?'nt':'largeLabel'" prop="NotifyTime">
              <el-date-picker
                v-model="data.NotifyTime"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                size="mini"
                type="datetime"
                placeholder="选择日期"
                style="width:100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="通知状态" prop="NotifyStatus">
              <el-select size="mini" v-model="data.NotifyStatus" style="width:100%;">
                <el-option value="待通知" />
                <el-option value="已通知" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>-->
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RentMonSetId: 0,
        SchoolId: null,
        GroupId:null,
        // RentMonDate: "",
        RentMon: "",
        WaitTime: "",
        NotifyTime: "",
        Kind: "话费",
      },
      hasSet: false,
      schools: [],
      groups:[],
      api: require("@/api/consume/rentmon").default,
      school_api: require("@/api/st/school").default,
      groupApi: require("@/api/st/group").default,
      packApi: require("@/api/consume/package").default,
      isMB: this.$store.state.isMB,
      rules: {
        SchoolId: [{ required: true, message: "请选择学校" }],
        RentMon: [{ required: true, message: "请选择月份" }],
        WaitTime: [{ required: true, message: "请选择预约扣费时间" }],
        NotifyTime: [{ required: true, message: "请选择扣费成功通知时间" }],
        Kind: [{ required: true, message: "请选择类型" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      if(this.data.GroupId===0) {
        this.data.GroupId=null
      }
      this.getOption();
    },
    setDate(date) {
      if (date) {
        // this.data.RentMonDate = date;
        this.data.RentMon = date;
      } else {
        // this.data.RentMonDate = "";
        this.data.RentMon = "";
      }
      this.checkSet();
    },
    onBeforeSave() {
      // console.log(this.data.NotifyTime>this.data.WaitTime)
      if(this.data.Kind == "话费") {
        if (!(this.data.NotifyTime > this.data.WaitTime)) {
          this.$message.error("扣费成功通知时间需大于预约扣费时间");
          return false;
        }
      } else {
        this.data.NotifyTime = "";
      }
      if(!this.data.GroupId) {
        this.data.GroupId=0
      }
      return true;
    },
    onEditOpened() {
      this.getOption();
      this.checkSet();
    },
    getOption() {
      this.school_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.schools = res.Data;
      });
    },
    checkSet() {
      //this.data.GroupId=null;
      this.groupApi.list({SchoolId:this.data.SchoolId}).then((res) => {
        if (res.Code == 0) this.groups = res.Data;
      });
      if(!this.data.SchoolId || !this.data.RentMon) return;
      this.loading(true);
      this.packApi.list({ SchoolId: this.data.SchoolId, Status: 1, StartMonthDate: this.data.RentMon }).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.hasSet = res.Data.length > 0;
          if(!this.hasSet && this.data.Kind == "赠送") this.data.Kind = "";
        }
      })
    },
    changeKind(e){
      // console.log(123)
      // console.log(e)
      if(e==='赠送') {
        this.data.GroupId=null
      }
    },
    onClosed() {
      this.hasSet = false;
    },
    onSaved() {
      console.log(this.data)
      if(this.data.GroupId===0) {
        this.data.GroupId=null
      }
    }
  }
};
</script>
<style lang="scss">
.waitLabel {
  .el-form-item__label {
    width: 138px !important;
  }
  .el-form-item__content {
    margin-left: 138px !important;
  }
}
.nt {
  .el-form-item__label {
    width: 85px !important;
  }
  .el-form-item__content {
    margin-left: 85px !important;
  }
}
</style>